// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___2HNZN","contentWrapper":"contentWrapper___1PcUU","text":"text___1mXa4","bttn":"bttn___2q95y"};